export default __webpack_public_path__ + "69bfb771c34f0e223c26c47aa94c9b74.png";